module.exports = __webpack_public_path__ + "static/media/20160512_185625.7c8c5b46.jpg";